import { FC } from 'react';
import Layout from '@/components/layout/Layout';
import BookCardItem from '@/components/ui/book-card-item/BookCardItem';
import Pagination from '@/components/ui/pagination/Pagination';
import PageHeading from '@/components/ui/page-heading/PageHeading';
import SectionTitleMenu from '@/components/ui/section-title-menu/SectionTitleMenu';
import Breadcrumbs from '@/components/ui/breadcrumbs/Breadcrumbs';
import { useGetUrlPath } from '@/hooks/useGetUrlPath';
import { BOOKS_FOR_PAGE } from '@/helpers/variables';
import { IGenreBooksPage } from '@/interfaces/genreBooksPage.interface';

interface IWebtoonsProps {
  books: IGenreBooksPage;
}

const Webtoons: FC<IWebtoonsProps> = ({ books }) => {
  const pagesCount = Math.ceil(books?.books.total_count / BOOKS_FOR_PAGE);

  //Seo block
  const SEO_TITLE = `Бесплатно скачать книги жанра Вебтуны | КучаКниг`;
  const SEO_DESCRIPTION = `В электронной библиотеке КучаКниг. можно скачать книги из жанра «Вебтуны»`;
  const SEO_CANONICAL = `/webtoons/`;

  return (
    <Layout title={SEO_TITLE} description={SEO_DESCRIPTION} canonicalHref={SEO_CANONICAL} pageHref={useGetUrlPath()}>
      <Breadcrumbs pageName="Вебтуны" />
      <SectionTitleMenu>
        <PageHeading title="Вебтуны" extraClassName="pageHeading_plain" />
      </SectionTitleMenu>
      <div data-cards="list" className="cardsWrapper">
        {books.books.data.length > 0 ? books.books.data.map((book) => <BookCardItem createdAt={book.created_at} alias={book.alias} author={book.author} book={book} rating={book.rating} key={book.id} />) : <div>Нет книг</div>}
      </div>
      <Pagination pagesCount={pagesCount ?? 0} postName={`webtoons/page=`} />
    </Layout>
  );
};

export default Webtoons;
